import { GeneralState, Module, State } from '@common/types';

const generalState: GeneralState = { isFetching: false, isSaving: false, error: [] };

export const getInitialState = <S>(initialState: S, localStorageKey: Module): State & S & GeneralState => {
  const localStorageState = localStorage.getItem(localStorageKey);
  const storedState = localStorageState ? JSON.parse(localStorageState) : {};
  return { ...generalState, ...initialState, ...storedState };
};
